import Login from '@containers/auth/Login';
import api from '@api/axios.js';
import { useEffect } from 'react';

const LoginPage = () => {
  useEffect(() => {
    api
      .get('/')
      .then((res) => {
        console.log('LoginPage :: res');
        console.log(res);
      })
      .catch((err) => {
        console.log('LoginPage :: err');
        console.log(err);
      });
  }, []);

  return <Login />;
};

export default LoginPage;
